import BaseFragmentSerializer from '@square/dashboard-data/serializers/fragment';
import { isEmpty } from '@ember/utils';
export default class Membership extends BaseFragmentSerializer {
  keyForAttribute(attr) {
    if (attr === 'categoryId') {
      return 'id';
    }
    return attr;
  }
  serialize(snapshot, options) {
    const json = super.serialize(snapshot, options);
    if (isEmpty(json.id)) {
      delete json.id;
    }
    return json;
  }
}